import SafeConsole from '../util/ConsoleUtils';
import { vhtSegments } from './megaUseCases';
import REST_API_SHS_WEB from './restApi.SHS-WEB.js';
import REST_API_SHS_SPRINT from './restApi.SHS-SPRINT.js';
import REST_API_SHS_ASURION from './restApi.SHS-ASURION.js';
import { PartnerConfigName } from 'packages/smart-home-support/api/models';

// Configurations key names
export const CONFIG_KEY_NAMES = {
  recaptcha: 'recaptcha',
  mixpanelApiKey: 'mixpanelApiKey',
  mixpanelSource: 'mixpanelSource',
  carrier: 'carrier',
  scope: 'scope',
};

// REST API configurations per partner
const REST_API_CONFIG = {};
REST_API_CONFIG[PartnerConfigName.Verizon] = REST_API_SHS_WEB;
REST_API_CONFIG[PartnerConfigName.Sprint] = REST_API_SHS_SPRINT;
REST_API_CONFIG[PartnerConfigName.Asurion] = REST_API_SHS_ASURION;
REST_API_CONFIG[PartnerConfigName.TechCoachHome] = REST_API_SHS_WEB;

export default {
  REST_URL: function(apiName) {
    if (!apiName) {
      SafeConsole.error('REST configuration error: apiName is falsy');
    } else {
      const url = REST_API_CONFIG[globals.REACT_APP_PARTNER].URL[apiName];
      if (!url) {
        SafeConsole.error('REST configuration error: url is not supplied; apiName = ' + apiName);
      } else {
        return url;
      }
    }
    return '';
  },

  KEY: function(keyName) {
    if (!keyName) {
      SafeConsole.error('REST configuration error: keyName is falsy');
    } else {
      const keyValue = REST_API_CONFIG[globals.REACT_APP_PARTNER].KEY[keyName];
      if (!keyValue) {
        SafeConsole.error('REST configuration error: keyValue is not supplied; keyName = ' + keyName);
      } else {
        SafeConsole.log('config.KEY : keyName = ' + keyName + ', keyValue = ' + keyValue);
        return keyValue;
      }
    }
    return '';
  },

  VHT_SEGMENTS: function(megaUseCase) {
    if (!megaUseCase) {
      SafeConsole.error('VHT_SEGMENTS configuration error: megaUseCase is falsy');
    } else {
      const vhtSegment = vhtSegments[globals.REACT_APP_PARTNER][megaUseCase];
      if (!vhtSegment) {
        SafeConsole.error('VHT_SEGMENTS configuration error: vhtSegment is not supplied; megaUseCase = ' + megaUseCase);
      } else {
        return vhtSegment;
      }
    }
    return '';
  },
};



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/config/config.js